/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_NoInputs */

const en_mk_sec_pg_ledger_no = /** @type {(inputs: Mk_Sec_Pg_Ledger_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet`)
};

const id_mk_sec_pg_ledger_no = /** @type {(inputs: Mk_Sec_Pg_Ledger_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum`)
};

/**
* | output |
* | --- |
* | "Not yet" |
*
* @param {Mk_Sec_Pg_Ledger_NoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_no = /** @type {((inputs?: Mk_Sec_Pg_Ledger_NoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_NoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_no(inputs)
	return en_mk_sec_pg_ledger_no(inputs)
});